import React, { useEffect, useState } from "react";
import {
  Container,
  Contact,
  Resume,
  Actions,
  Files,
  ViewInput,
} from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import { MdDelete, MdDownload, MdUpload } from "react-icons/md";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useAuth } from "../../../hooks/AuthContext";
import Status from "../../../components/status";
import photoUser from "./../../../images/user.png";
import { format } from "date-fns";
import { Button, Input, Modal, Select, Spin } from "antd";
import { Message } from "../../../GlobalStyles";
import { getValue } from "../../../services/functions";

export default function OSDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [order, setOrder] = useState({
    items: [],
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [observation, setObservation] = useState("");
  const [company_id, setCompany_id] = useState("");
  const [companies, setCompanies] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalEdit, setVisibleModalEdit] = useState(false);
  const [visibleModalRecused, setVisibleModalRecused] = useState(false);
  const [visibleModalMessage, setVisibleModalMessage] = useState(false);
  const [files, setFiles] = useState([]);
  const [filesUp, setFilesUp] = useState([]);

  useEffect(() => {
    loadingOS();
  }, [id]);

  async function loadingOS() {
    await api
      .get(`/order/${id}`)
      .then((response) => {
        setFiles(response.data.docs);
        setOrder(response.data);
        let message = response.data.messages.pop();
        if (message) {
          response.data.messages.push(message);
          if (message.type == "tecnico") {
            setVisibleModalMessage(true);
          }
        }
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          setError(response.data.message);
          toast.warn(response.data.message);
        } else {
          setError("Erro Interno. verifique sua conexão e tente novamente");
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);

    await api
      .get(`/companies-confirm?order_id=${id}`)
      .then((response) => {
        let companies = response.data;

        companies.map((item) => {
          item.value = item.razao_social;
          item.label = item.razao_social;
        });

        setCompanies(companies);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function uploadDocs(filesUpload) {
    filesUpload.map(async (item) => {
      const data = new FormData();
      data.append("type", user.type);
      data.append("file", item, item.name);
      await api
        .post(`/doc/${order.id}`, data)
        .then(async (response) => {
          setFilesUp((prevFiles) => {
            const newState = [...prevFiles];
            newState.shift();
            return newState;
          });
          setFiles((prevFiles) => [...prevFiles, response.data]);
          toast.success(`O documento ${item.name} foi enviado com sucesso`);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        });
    });
  }

  async function deleteDoc(fileDelete) {
    await api
      .delete(`/doc/${fileDelete.id}?type=${user.type}`)
      .then(async (response) => {
        setFiles((prevFiles) => {
          const newFiles = [...prevFiles];
          const idx = newFiles.indexOf(fileDelete);
          if (idx > -1) {
            newFiles.splice(idx, 1);
          }
          return newFiles;
        });
        toast.success(
          `O documento ${String(fileDelete.file).substr(
            33
          )} foi deletado com sucesso`
        );
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function editOrder() {
    setIsLoadingModal(true);
    await api
      .put(`/order/${id}`, {
        observation: observation,
        company_id: company_id,
      })
      .then((response) => {
        setOrder(response.data);
        setVisibleModalEdit(false);
        toast.success("OS editada com sucesso");
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }
  return (
    <Container>
      {loading ? (
        <Spin style={{ marginTop: 50 }} />
      ) : (
        <>
          {error ? (
            <Message>{error}</Message>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <h1 style={{ marginRight: 10 }}>Ordem de Serviço #{id}</h1>
                <Status status={order.status} />
                {order.urgent && (
                  <Status isUrgent={true} style={{ marginLeft: 10 }} />
                )}
              </div>
              <p style={{ fontSize: 12, margin: "5px 0 15px 0" }}>
                Aberta em{" "}
                {format(new Date(order.create_at), "dd/MM/yyyy HH:mm")}
              </p>
              {order.collaborator && (
                <>
                  <h3>Técnico</h3>
                  <Contact>
                    <img
                      src={
                        order.collaborator.photo
                          ? order.collaborator.photo_url
                          : photoUser
                      }
                    />
                    <p>{order.collaborator.name}</p>
                  </Contact>
                </>
              )}
              {order.order_doc_recused && (
                <>
                  <h3>Visualizar OS que foi solicitada a revisão</h3>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate(`/clientes/os/${order.order_linked_id}`);
                    }}
                    style={{
                      marginBottom: 15,
                      height: 40,
                      width: 150,
                      borderRadius: 50,
                      fontWeight: 600,
                    }}
                  >{`Visualizar OS: ${order.order_linked_id}`}</Button>
                </>
              )}

              <h3>Documentos do Franqueado</h3>
              <Files>
                {(order.status == "pendente" ||
                  order.status == "alteracao") && (
                  <div
                    className="button"
                    for="avatar"
                    style={{ position: "relative" }}
                  >
                    <p
                      style={{ color: "#fff", fontSize: 16, margin: "0 10px" }}
                    >
                      Upload
                    </p>
                    <MdUpload
                      size={22}
                      color="#fff"
                      style={{ marginLeft: 15 }}
                    />
                    <input
                      id="avatar"
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        opacity: 0,
                      }}
                      multiple
                      type="file"
                      accept="image/"
                      onChange={(file) => {
                        let filesUp = Object.values(file.target.files);
                        filesUp.map((item) => {
                          item.file_url = URL.createObjectURL(item);
                        });
                        setFilesUp((prevFiles) => [...prevFiles, ...filesUp]);
                        uploadDocs(filesUp);
                      }}
                    />
                  </div>
                )}
                {files.map((item) => {
                  if (item.type == "cliente") {
                    return (
                      <div key={item.file}>
                        <p>{String(item.file).substr(33)}</p>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            minHeight: 20,
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          <MdDownload
                            onClick={() => {
                              window.open(
                                "https://guruseg-data.s3.sa-east-1.amazonaws.com/" +
                                  item.file
                              );
                            }}
                            style={{ cursor: "pointer", marginLeft: 10 }}
                            size={22}
                            color="#000"
                          />
                          {order.status == "pendente" && (
                            <MdDelete
                              onClick={() => {
                                deleteDoc(item);
                              }}
                              style={{ cursor: "pointer", marginLeft: 10 }}
                              size={22}
                              color="#000"
                            />
                          )}
                        </div>
                      </div>
                    );
                  }
                })}
                {filesUp.map((item) => {
                  return (
                    <div key={item.name}>
                      <p>{item.name}</p>
                      <Spin size="small" style={{ margin: "0 0 0 5px" }} />
                    </div>
                  );
                })}
              </Files>
              <h3>Documentos do Técnico</h3>
              <Files>
                {!files.find((item) => item.type == "tecnico") && (
                  <Message style={{ width: "auto", fontSize: 14 }}>
                    Nenhum documento enviado até o momento
                  </Message>
                )}
                {files.map((item) => {
                  if (item.type == "tecnico") {
                    return (
                      <div key={item.file}>
                        <p>{String(item.file).substr(33)}</p>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            minHeight: 20,
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          <MdDownload
                            onClick={() => {
                              window.open(
                                "https://guruseg-data.s3.sa-east-1.amazonaws.com/" +
                                  item.file
                              );
                            }}
                            style={{ cursor: "pointer", marginLeft: 10 }}
                            size={22}
                            color="#000"
                          />
                          <MdDelete
                            onClick={() => {
                              deleteDoc(item);
                            }}
                            style={{ cursor: "pointer", marginLeft: 10 }}
                            size={22}
                            color="#000"
                          />
                        </div>
                      </div>
                    );
                  }
                })}
              </Files>

              {!!order.collaborators && (
                <>
                  <h3 style={{ marginBottom: 5 }}>Funcionários</h3>
                  <p style={{ marginBottom: 15 }}>{order.collaborators}</p>
                </>
              )}
              {order.observation && (
                <>
                  <h3 style={{ marginBottom: 5 }}>Observação do Franqueado</h3>
                  <p style={{ marginBottom: 15 }}>{order.observation}</p>
                </>
              )}
              {order.observationCollaborator && (
                <>
                  <h3 style={{ marginBottom: 5 }}>Observação do Técnico</h3>
                  <p style={{ marginBottom: 15 }}>
                    {order.observationCollaborator}
                  </p>
                </>
              )}
              {order.status == "finalizado" && order.order_doc_recused && (
                <>
                  <h3>
                    {order.order_linked_id
                      ? "Visualizar OS de revisão"
                      : "Solicitar OS caso Documentação seja negada"}
                  </h3>
                  <Button
                    type="primary"
                    onClick={() => {
                      if (order.order_linked_id) {
                        navigate(`/clientes/os/${order.order_linked_id}`);
                      } else {
                        setVisibleModalRecused(true);
                      }
                    }}
                    style={{
                      marginBottom: 15,
                      height: 40,
                      width: "fit-content",
                      borderRadius: 50,
                    }}
                  >
                    {order.order_linked_id
                      ? `Visualizar OS: ${order.order_linked_id}`
                      : "Solicitar"}
                  </Button>
                </>
              )}
              {order.company_id && (
                <>
                  <h3>Formulário da Empresa</h3>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate(`/view-company/${order.company_id}`);
                    }}
                    style={{
                      marginBottom: 15,
                      height: 40,
                      width: "fit-content",
                      borderRadius: 50,
                    }}
                  >
                    Visualizar
                  </Button>
                </>
              )}
              <h3 style={{ marginBottom: 5 }}>Setor</h3>
              <p style={{ marginBottom: 15 }}>{order.sector}</p>
              <div
                className="service"
                style={{ border: "none", padding: "0 25px" }}
              >
                <p style={{ flex: 1 }}>Serviço</p>
                <p>Quantidade</p>
              </div>
              <Resume>
                <div>
                  {order?.items?.map((item) => {
                    return (
                      <div className="service">
                        <p style={{ flex: 1 }}>{item.name}</p>
                        <p>{item.amount}x</p>
                      </div>
                    );
                  })}
                </div>
                <div class="checkout-summary">
                  <div class="left-section">
                    {order.asaas_integration && (
                      <Status status={order.status_payment} isPayment={true} />
                    )}
                    {order.redemption && (
                      <p class="discount-info">
                        Cupom aplicado:
                        <span style={{ color: "#FF0000", marginLeft: 10 }}>
                          {order.redemption.name.toUpperCase()}
                        </span>
                      </p>
                    )}
                  </div>
                  <div class="right-section">
                    <div class="line">
                      <span>Total</span>
                      <span class="amount">
                        {getValue(order.totalValue || 0)}
                      </span>
                    </div>

                    {order.redemption && (
                      <div class="line">
                        <span>Desconto</span>
                        <span class="amount">
                          {getValue(order.redemption.value)}
                        </span>
                      </div>
                    )}
                    <div class="line">
                      <span class="badge">{order.totalServices} itens</span>
                      <span class="final-label">Valor final</span>
                      <span class="amount">
                        {getValue(
                          order.redemption
                            ? order.totalValue - order.redemption.value
                            : order.totalValue || 0
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </Resume>
              <Actions>
                {order.status == "finalizado" && (
                  <>
                    <Button
                      type="primary"
                      onClick={async () => {
                        setMessage("");
                        setVisibleModal(true);
                      }}
                    >
                      Solicitar Alteração
                    </Button>
                  </>
                )}
                {(order.status == "pendente" ||
                  order.status == "alteracao") && (
                  <Button
                    type="primary"
                    onClick={async () => {
                      setMessage("");
                      setVisibleModal(true);
                    }}
                  >
                    Confirmar Documentos
                  </Button>
                )}
                {!!order.messages.length && (
                  <Button
                    type="primary"
                    onClick={async () => {
                      setVisibleModalMessage(true);
                    }}
                  >
                    Ver Mensagens
                  </Button>
                )}

                {(order.status == "aberto" ||
                  (order.status == "pendente" && !order.collaborator_id)) && (
                  <Button
                    type="primary"
                    onClick={async () => {
                      await api
                        .put(`/order-cancel/${order.id}`, {
                          status: "andamento",
                        })
                        .then((response) => {
                          toast.success(
                            "Ordem de serviço cancelada com sucesso"
                          );
                          loadingOS();
                        });
                    }}
                  >
                    Cancelar Solicitação
                  </Button>
                )}

                <Button
                  type="primary"
                  onClick={async () => {
                    setObservation(order.observation);
                    setCompany_id(order.company_id);
                    setVisibleModalEdit(true);
                  }}
                >
                  Editar OS
                </Button>
              </Actions>
            </>
          )}
        </>
      )}

      <Modal
        title="Mensagens"
        width={500}
        open={visibleModalMessage}
        okText={"FECHAR"}
        cancelButtonProps={{
          style: {
            display: "none",
          },
        }}
        onCancel={() => {
          setVisibleModalMessage(false);
        }}
        onOk={() => {
          setVisibleModalMessage(false);
        }}
      >
        {order?.messages?.map((item) => {
          return (
            <p
              style={{
                lineHeight: 1.35,
                marginBottom: 7,
              }}
            >
              <strong>
                {item.type == "tecnico" ? "Técnico: " : "Franqueado: "}
              </strong>
              {item.message}
              <br />
              <span style={{ fontSize: 11 }}>
                {format(new Date(item.create_at), "dd/MM/yyyy HH:mm")}
              </span>
            </p>
          );
        })}
      </Modal>
      <Modal
        title={"Solicitar OS caso Documentação seja negada"}
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModalRecused}
        okText={"Confirmar"}
        cancelText="Cancelar"
        onOk={async () => {
          setIsLoadingModal(true);
          await api
            .put(`/doc-recused-order/${order.id}`, {
              observation: message,
            })
            .then((response) => {
              toast.success(
                "Solicitação de revisão do documento da OS realizada com sucesso"
              );
              navigate(`/clientes/os/${response.data.id}`);
            })
            .catch(({ response }) => {
              if (response) {
                if (response.data) {
                  if (response.data.message) {
                    toast.warn(response.data.message);
                  } else {
                    toast.error(
                      "Erro Interno. verifique sua conexão e tente novamente"
                    );
                  }
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            });
          setIsLoadingModal(false);
          setVisibleModalRecused(false);
        }}
        onCancel={() => {
          setVisibleModalRecused(false);
        }}
      >
        <ViewInput>
          <p>{"Deseja deixar uma mensagem para o técnico?"}</p>
          <Input.TextArea
            value={message}
            placeholder={"descreva o que precisa"}
            style={{ minHeight: "80px" }}
            onChange={(text) => {
              setMessage(text.target.value);
            }}
          />
        </ViewInput>
      </Modal>
      <Modal
        title={"Confirmar Documentação"}
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={"Confirmar"}
        cancelText="Cancelar"
        onOk={async () => {
          setIsLoadingModal(true);
          if (order.status == "finalizado") {
            await api
              .put(`/status/${order.id}`, {
                status: "alteracao",
                message,
              })
              .then((response) => {
                toast.success(
                  "Solicitação de alteração da Ordem de Serviço realizada com sucesso"
                );
                loadingOS();
              })
              .catch(({ response }) => {
                if (response) {
                  if (response.data) {
                    if (response.data.message) {
                      toast.warn(response.data.message);
                    } else {
                      toast.error(
                        "Erro Interno. verifique sua conexão e tente novamente"
                      );
                    }
                  } else {
                    toast.error(
                      "Erro Interno. verifique sua conexão e tente novamente"
                    );
                  }
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              });
          } else {
            if (order.collaborator_id) {
              await api
                .put(`/status/${order.id}`, {
                  status: "andamento",
                  message,
                })
                .then((response) => {
                  toast.success("Documentos confirmados com sucesso");
                  loadingOS();
                })
                .catch(({ response }) => {
                  if (response) {
                    if (response.data) {
                      if (response.data.message) {
                        toast.warn(response.data.message);
                      } else {
                        toast.error(
                          "Erro Interno. verifique sua conexão e tente novamente"
                        );
                      }
                    } else {
                      toast.error(
                        "Erro Interno. verifique sua conexão e tente novamente"
                      );
                    }
                  } else {
                    toast.error(
                      "Erro Interno. verifique sua conexão e tente novamente"
                    );
                  }
                });
            } else {
              await api
                .put(`/status/${order.id}`, {
                  status: "confirm",
                  message,
                })
                .then((response) => {
                  if (response.data.collaborator_id) {
                    toast.success(
                      "Documentos confirmados com sucesso e um técnico já foi vinculado a sua OS"
                    );
                  } else {
                    toast.success("Documentos confirmados com sucesso");
                  }
                  loadingOS();
                })
                .catch(({ response }) => {
                  if (response) {
                    if (response.data) {
                      if (response.data.message) {
                        toast.warn(response.data.message);
                      } else {
                        toast.error(
                          "Erro Interno. verifique sua conexão e tente novamente"
                        );
                      }
                    } else {
                      toast.error(
                        "Erro Interno. verifique sua conexão e tente novamente"
                      );
                    }
                  } else {
                    toast.error(
                      "Erro Interno. verifique sua conexão e tente novamente"
                    );
                  }
                });
            }
          }
          setIsLoadingModal(false);
          setVisibleModal(false);
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <ViewInput>
          <p>{"Deseja deixar uma mensagem para o técnico?"}</p>
          <Input.TextArea
            value={message}
            placeholder={"descreva o que precisa"}
            style={{ minHeight: "80px" }}
            onChange={(text) => {
              setMessage(text.target.value);
            }}
          />
        </ViewInput>
      </Modal>
      <Modal
        open={visibleModalEdit}
        onCancel={() => {
          setVisibleModalEdit(false);
        }}
        onOk={() => {
          editOrder();
        }}
        loading={isLoadingModal}
        title="Editar OS"
        okText="SALVAR"
        cancelText="FECHAR"
      >
        <div
          style={{
            margin: "10px 0",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ViewInput style={{ marginRight: 0 }}>
            <p>Observação</p>
            <Input.TextArea
              type="text"
              value={observation}
              placeholder="deixe aqui uma observação para o técnico."
              onChange={(text) => {
                setObservation(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput style={{ marginRight: 0 }}>
            <p>Vincular Formulário da Empresa</p>
            <Select
              style={{
                width: "100%",
                fontSize: 14,
                textAlign: "left",
              }}
              value={company_id}
              notFoundContent={<>Nenhuma empresa encontrada</>}
              onChange={(value) => {
                setCompany_id(value);
              }}
              placeholder="procurar por nome"
            >
              <Select.Option value={""}>Nenhum Formulário</Select.Option>
              {companies.map((item) => {
                return (
                  <Select.Option value={item.id}>{item.label}</Select.Option>
                );
              })}
            </Select>
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
}
